export enum ProductMainGroups {
  shoes = 'shoes',
  apparel = 'apparel',
  accessories = 'accessories',
}
